import { Schema } from 'further-types/lp/account';

export const AccountSectionLabels = {
  [Schema.AccountSection.Assets]: 'Assets',
  [Schema.AccountSection.Expenses]: 'Expenses',
  [Schema.AccountSection.Income]: 'Income',
  [Schema.AccountSection.Payables]: 'Payables',
  [Schema.AccountSection.PartnersCapital]: "Partners' Capital",
};

// Reverse mapping: from label (case-insensitive) to enum value
export const AccountSectionLabelToEnum: Record<string, Schema.AccountSection> =
  {
    // Human-readable labels (lowercase for case-insensitive matching)
    assets: Schema.AccountSection.Assets,
    expenses: Schema.AccountSection.Expenses,
    income: Schema.AccountSection.Income,
    payables: Schema.AccountSection.Payables,
    "partners' capital": Schema.AccountSection.PartnersCapital,
    'partners capital': Schema.AccountSection.PartnersCapital,
    partnerscapital: Schema.AccountSection.PartnersCapital,
  };

export function parseAccountSection(
  value: string | undefined | null,
): Schema.AccountSection | undefined {
  if (!value) return undefined;
  const normalized = value.toLowerCase().trim();
  return AccountSectionLabelToEnum[normalized];
}
